<template>
  <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 mb-lg-3">
    <b-card
      no-header
      no-body
      class="shadow-none border-radius-10 category-titles"
      :id="`${shortHand}_card`"
    >
      <div class="category-titles-card d-block" v-on:click="onTitleClick()">
        <div class="category-titles-card-header">
          <b-card-title>{{ title }}</b-card-title>
        </div>
        <b-form-group
            v-if="title=='Other Debt Payments & Obligations' && !month_debs"
            class="custom-form-control mb-3 p-2"
          >
            <b-row>
              <b-col cols="6" sm="6" md="6" lg="6">
                <div class="inputGroup mb-2">
                  <input
                    id="obligationPaymentsYes"
                    type="radio"
                    @click="onYesClick"
                    value="yes"
                    v-model="month_debs"
                    name="obligationPayments"
                  />
                  <label for="obligationPaymentsYes"
                    >Yes</label
                  >
                </div>
              </b-col>
              <b-col cols="6" sm="6" md="6" lg="6">
                <div class="inputGroup mb-2">
                  <input
                    id="obligationPaymentsNo"
                    type="radio"
                    @click="onNoClick"
                    value="no"
                    v-model="month_debs"
                    name="obligationPayments"
                  />
                  <label for="obligationPaymentsNo"
                    >No</label
                  >
                </div>
              </b-col>
            </b-row>
          </b-form-group>
          <template v-else>
            <!-- <div
              class="category-titles-card-body clr-box-btns d-flex align-items-center justify-space-between"
            >
              <span
                class="clr-bx-btn category-titles-amount fixed-amount-value"
                v-if="!!fixAmount"
              >
                {{ value2 | currency("$", 0) }}
              </span>
              <span
                class="clr-bx-btn category-titles-amount your-amount-value"
                v-else
              >
                <template v-if="value2>=0">
                  {{ value2 | currency("$", 0) }}
                </template>
                <template v-else>
                  $0
                </template>
              </span>
              <span
                class="clr-bx-btn category-titles-amount peers-amount-value"
                v-if="showPeer"
              >
                {{ value1 | currency("$", 0) }}
              </span>
            </div> -->
            
            <div
              class="category-titles-card-body clr-box-btns d-flex align-items-center"
            >
              <span
                v-if="!!fixAmount"
                class="clr-bx-btn text-center py-1 px-1 fixed-amount"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Your Amount"
                :style="{ width: `${percantageCal(value2)}%` }"
              >
              {{ value2 | currency("$", 0) }}
              </span>
              <span
                v-else
                class="clr-bx-btn text-center py-1 px-1 your-amount"
                :class="{ 'negative-bg': getColor(value2) }"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Predicted Amount"
                :style="{ width: `${percantageCal(value2)}%` }"
              >
              <template v-if="value2>0">
                  {{ value2 | currency("$", 0) }}
                </template>
                <template v-else>
                  {{value1 | currency("$", 0)}}
                </template>
              </span>

              <span
                v-if="showPeer"
                class="clr-bx-btn text-center py-1 px-1 peers-amount"
                :class="{ 'negative-bg': getColor(value1) }"
                v-b-tooltip.hover="{ variant: 'primary' }"
                title="Your Peers"
                :style="{ width: `${percantageCal(value1)}%` }"
              >
              {{ value1 | currency("$", 0) }}
              </span>
            </div>
            <div class="edit-budget-amount">
              <div class="d-flex justify-content-between">
                <a
                  role="button"
                  class="mx-2 font-weight-bold your-amount-text"
                >
                  <i class="fas fa-pencil-alt mr-1"></i>
                  Your Amount
                </a>
                <span class="mx-2 font-weight-bold your-peers-text">
                  Your Peers
                </span>
              </div>
            </div>
        </template>
      </div>
      <div
        :id="`${shortHand}_card_click`"
        class="add-fudget-form"
        ref="ddd-n"
        :class="{ 'd-none': isHidden || defaultActive != title }"
      >
        <div class="position-relative d-block">
          <b-form class="m-1" @submit="onSubmit">
            <b-row class="mb-3">
              <b-col cols="6">
                <template v-if="checkIcon">
                  <b-button
                    @click="changeUsesvalue(title)"
                    class="get_advice_btn"
                    size="sm"
                  >
                  Ideas
                  </b-button>
                </template>
              </b-col>
              <b-col cols="6" class="text-right">
                <b-button
                  class="about-you-accordion clear-amount-btn"
                  size="sm"
                  variant="danger"
                  @click="
                    fixAmount = null;
                    fixAmt();
                  "
                  >Reset</b-button
                >
              </b-col>
            </b-row>
            <b-form-group label="Fixed Amount" class="custom-form-control">
              <NumberInput
                :model="fixAmount"
                @changeValue="numberValueChange"
                name="fixAmount"
                class="big-input-font"
              />
            </b-form-group>
            <b-form-group label="Frequency" class="custom-form-control">
              <b-form-select
                v-model="frequency"
                :options="[
                  { text: 'Monthly', value: 12 },
                  { text: 'Weekly', value: 52 },
                  { text: 'Quarterly', value: 4 },
                  { text: 'Semi-Annually', value: 2 },
                  { text: 'Annually', value: 1 },
                ]"
                :value="null"
                class="big-input-font"
              >
              </b-form-select>
            </b-form-group>
          </b-form>
          <b-form-group class="text-center">
            <b-button
              type="button"
              class="btn-green"
              size="sm"
              @click="closeClick()"
            >
              Close
              <!-- Update Edit Amount -->
            </b-button>
          </b-form-group>
        </div>
      </div>
    </b-card>
    <b-modal
      id="chatGptList"
      v-model="modalShow"
      scrollable
      size="xl"
      content-class="get-advice-modal"
      v-if="modalShow == true"
      hide-footer
    >
      <ChatGptList :uses="uses" />
    </b-modal>
  </b-col>
</template>
<script>
import NumberInput from "@/components/NumberInput";
import ChatGptList from "@/components/ChatGptList";
import transformer_38 from "@/transformers/transformer_new";
import transformer_links from "@/transformers/transformer_links";
export default {
  name: "budget-component",
  props: {
    title: String,
    value1: Number,
    value2: Number,
    frequencyOptions: Array,
    changedValues: Object,
    newValueMorgage: Object,
    newValueVahicle: Object,
    newValueDebt: Object,
    newValueSaving: Object,
    newValueHealth: Object,
    showPeer: Boolean,
    grid: Boolean,
    zip: String,
    age: {
      type: [String, Number],
    },
    defaultActiveTab: String,
    monthDebs: String,
    householdMembers: {
    type: [String, Number],
    }
  },
  components: {
    NumberInput,
    ChatGptList,
  },
  data() {
    return {
      modalShow: false,
      uses: "",
      isHidden: true,
      fixAmount: null,
      frequency: 12,
      defaultActive: "",
      month_debs:this.monthDebs,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  watch: {
    monthDebs:{
      handler(data) {
        this.month_debs = data;
      },
      deep: true,
    },
    defaultActiveTab: {
      handler(data) {
        this.defaultActive = data;
      },
      deep: true,
    },
    newValueMorgage: function (newVal) {
      if (this.title === "Rent or Mortgage Payment") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueVahicle: function (newVal) {
      if (this.title === "Car Payments") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueDebt: function (newVal) {
      if (this.title === "Other Debt Payments & Obligations") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueSaving: function (newVal) {
      if (this.title == "Amount to Savings Each Period") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueHealth: function (newVal) {
      if (this.title == "Health Insurance") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    grid: {
      handler(val) {
        this.grid = val;
      },
      deep: true,
      immediate: true,
    },
    fixAmount() {
      // this.$emit('changeValue', this.title,this.fixAmount? parseInt(this.unmaskMoneyValue(this.fixAmount))*this.frequency: null,this.fixAmount? this.unmaskMoneyValue(this.fixAmount) :null,this.frequency)
    },
    frequency() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
  },
  created() {},
  mounted() {
    //   console.log(this.title)
  },
  methods: {
    onYesClick(){
      this.month_debs = 'yes'
      this.$emit("openOtherDebt")
    },
    onNoClick(){
      const _this  =this
      setTimeout(() => {
        _this.month_debs = 'no'
        _this.$parent.month_debs='no';
        _this.$emit("submitDebt")
      }, 100);
    },
    closeClick(){
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    onTitleClick() {
      this.isHidden = false;
      if(this.title=='Other Debt Payments & Obligations'){
        if(this.month_debs){
          
          this.$parent.month_debs='yes';
          this.$emit("openOtherDebt");
        }
      // this.$emit("defaultActiveTabAction", this.title);
      } else{
      this.$emit("defaultActiveTabAction", this.title);
      }
    },
    changeUsesvalue(title) {
      // alert(title)
      const data = {
        title,
        predicted: this.value2,
        peer: this.value1,
        type: "Major",
        zip: this.zip,
        age: this.age,
        size: this.householdMembers,
      };
      this.uses = data;
      this.modalShow = true;
    },
    hideMenus() {
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    onSubmit(event) {
      event.preventDefault();
    },
    getColor(arg) {
      if (arg < 0) {
        return true;
      } else {
        return false;
      }
    },
    fixAmt() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
      this.fixAmt();
    },
    percantageCal(arg) {
      //   if(!!this.fixAmount){
      //     const fixAmount = parseInt(this.unmaskMoneyValue(this.fixAmount))
      //     const total = this.value1+fixAmount

      //     if(typeof arg === 'string')
      //         return (fixAmount/total)*100
      //     else
      //         return (arg/total)*100
      //   } else {
      const total = this.value1 + this.value2;
      if (total === 0 && this.grid === true) return 50;
      else if (total === 0 && this.grid === false) return 4;
      else return (arg / total) * 100;
      //   }
    },
    unmaskMoneyValue(val) {
      if (val && typeof val === "string")
        return val.replace("$", "").replace(",", "");
      else return val;
    },
  },
  computed: {
    checkIcon() {
      const short_hand = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
      return transformer_links[short_hand];
    },
    shortHand() {
      return Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
    },
  },
};
</script>
